var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgMarkerStar = function SvgMarkerStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 22",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "MarkerStar_svg__a",
    d: "M1240.746 256.998c-1.804-3.576-6.186-5.026-9.762-3.222-3.576 1.804-4.994 6.315-3.222 9.762 1.74 3.448 5.541 10.858 5.541 10.858a1.05 1.05 0 0 0 1.902 0s4.51-8.796 5.54-10.858c1.032-2.062 1.064-4.414 0-6.54zm-3.491 7.688l-2.99-1.804-2.989 1.804.794-3.4-2.641-2.288 3.478-.295 1.359-3.207 1.359 3.207 3.478.295-2.641 2.287z"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#MarkerStar_svg__a",
    transform: "translate(-1227 -253)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarkerStar, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;